(function () {
  'use strict';
  var config = document.currentScript;
  if (!config) return;
  var ready = false;
  var loading = null;
  var pending = false;
  config.dataset.state = 'idle';

  function ensure() {
    if (ready) return Promise.resolve();
    if (loading) return loading;
    var start = Date.now();
    config.dataset.state = 'loading';
    loading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var timer = setTimeout(function () {
        config.dataset.state = 'timeout';
        reject(new Error('Size guide script timed out'));
      }, 12000);
      script.src = config.dataset.guideSrc;
      script.dataset.lkcGuideAsset = 'true';
      script.onload = function () {
        clearTimeout(timer);
        ready = true;
        config.dataset.state = 'ready';
        config.dataset.scriptMs = String(Date.now() - start);
        resolve();
      };
      script.onerror = function () {
        clearTimeout(timer);
        script.remove();
        loading = null;
        config.dataset.state = 'error';
        reject(new Error('Size guide script could not load'));
      };
      document.head.appendChild(script);
    });
    return loading;
  }

  function warm(event) {
    if (event.target.closest && event.target.closest('.featured-quick-view-modal-btn, .quick-view-modal-btn, .toolbar-item-cart, [data-fg-open]')) {
      ensure().catch(function () {});
    }
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('pointerdown', warm, { passive: true });
  document.addEventListener('focusin', warm);
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-fg-open]');
    if (!trigger || ready || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    var original = trigger.innerHTML;
    trigger.setAttribute('aria-busy', 'true');
    if (config.dataset.loadingLabel) trigger.textContent = config.dataset.loadingLabel;
    ensure().then(function () {
      if (trigger.isConnected) trigger.click();
    }).catch(function () {}).then(function () {
      pending = false;
      trigger.innerHTML = original;
      trigger.removeAttribute('aria-busy');
    });
  }, true);
})();
